module.exports = __webpack_public_path__ + "static/media/NFBKC.1faa81bf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/shgn/footerLogos/desktop/NFBKC.svg
// module id = 114
// module chunks = 0